"use client";
import { jsx as o } from "react/jsx-runtime";
import * as n from "@radix-ui/react-context-menu";
import { forwardRef as a, isValidElement as d } from "react";
import { appendToChildren as x } from "../../../utils/appendToChildren.mjs";
import { DEFAULT_ICON_CLASS_NAME as m } from "../../../utils/iconDefaults.mjs";
import { Check as l, ChevronRight as C } from "../Icon/icons.gen.mjs";
import { Text as p } from "../Text/Text.mjs";
const v = (t) => /* @__PURE__ */ o(n.Root, { "data-slot": "context-menu", ...t }), M = a((t, e) => /* @__PURE__ */ o(n.Trigger, { "data-slot": "context-menu-trigger", ...t, ref: e }));
M.displayName = "ContextMenuTrigger";
const s = (t) => /* @__PURE__ */ o(n.Portal, { "data-slot": "context-menu-portal", ...t }), b = a((t, e) => /* @__PURE__ */ o(s, { children: /* @__PURE__ */ o(n.Content, { "data-slot": "context-menu-content", ...t, ref: e }) }));
b.displayName = "ContextMenuContent";
const g = a((t, e) => /* @__PURE__ */ o(n.Group, { "data-slot": "context-menu-group", ...t, ref: e }));
g.displayName = "ContextMenuGroup";
const N = a(
  ({ children: t, fontSize: e = "sm", fontWeight: r = "semibold", fontFamily: u = "inter", ...i }, c) => /* @__PURE__ */ o(n.Label, { "data-slot": "context-menu-label", ...i, ref: c, children: /* @__PURE__ */ o(p, { asChild: !0, fontSize: e, fontWeight: r, fontFamily: u, children: d(t) ? t : /* @__PURE__ */ o("span", { children: t }) }) })
);
N.displayName = "ContextMenuLabel";
const I = a((t, e) => /* @__PURE__ */ o(n.Item, { "data-slot": "context-menu-item", ...t, ref: e }));
I.displayName = "ContextMenuItem";
const h = a((t, e) => /* @__PURE__ */ o(n.CheckboxItem, { "data-slot": "context-menu-checkbox-item", ...t, ref: e }));
h.displayName = "ContextMenuCheckboxItem";
const y = a((t, e) => /* @__PURE__ */ o(n.RadioGroup, { "data-slot": "context-menu-radio-group", ...t, ref: e }));
y.displayName = "ContextMenuRadioGroup";
const S = a((t, e) => /* @__PURE__ */ o(n.RadioItem, { "data-slot": "context-menu-radio-item", ...t, ref: e }));
S.displayName = "ContextMenuRadioItem";
const R = a(
  ({ children: t, ...e }, r) => /* @__PURE__ */ o(n.ItemIndicator, { "data-slot": "context-menu-item-indicator", ...e, ref: r, children: t ?? /* @__PURE__ */ o(l, { "data-slot": "context-menu-check-icon", "aria-hidden": "true", className: m }) })
);
R.displayName = "ContextMenuItemIndicator";
const f = a((t, e) => /* @__PURE__ */ o(n.Separator, { "data-slot": "context-menu-separator", ...t, ref: e }));
f.displayName = "ContextMenuSeparator";
const j = (t) => /* @__PURE__ */ o(n.Sub, { "data-slot": "context-menu-sub", ...t }), T = a(
  ({
    children: t,
    icon: e = /* @__PURE__ */ o(
      C,
      {
        "data-slot": "context-menu-sub-trigger-icon",
        "aria-hidden": "true",
        className: m
      }
    ),
    asChild: r,
    ...u
  }, i) => /* @__PURE__ */ o(n.SubTrigger, { "data-slot": "context-menu-sub-trigger", asChild: r, ...u, ref: i, children: x(t, e, r) })
);
T.displayName = "ContextMenuSubTrigger";
const k = a((t, e) => /* @__PURE__ */ o(s, { children: /* @__PURE__ */ o(n.SubContent, { "data-slot": "context-menu-sub-content", ...t, ref: e }) }));
k.displayName = "ContextMenuSubContent";
const A = a((t, e) => /* @__PURE__ */ o(n.Arrow, { "data-slot": "context-menu-arrow", ...t, ref: e }));
A.displayName = "ContextMenuArrow";
export {
  A as ContextMenuArrow,
  h as ContextMenuCheckboxItem,
  b as ContextMenuContent,
  g as ContextMenuGroup,
  I as ContextMenuItem,
  R as ContextMenuItemIndicator,
  N as ContextMenuLabel,
  s as ContextMenuPortal,
  y as ContextMenuRadioGroup,
  S as ContextMenuRadioItem,
  v as ContextMenuRoot,
  f as ContextMenuSeparator,
  j as ContextMenuSub,
  k as ContextMenuSubContent,
  T as ContextMenuSubTrigger,
  M as ContextMenuTrigger
};
